module.exports = __webpack_public_path__ + "static/img/commando.386e8eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/commando.png
// module id = CzxX
// module chunks = 0